<template>
  <div v-if="show">
    <el-form label-position="top" size="small">
      <template
        v-if="
          data.eventOptions &&
          Object.keys(data.eventOptions).indexOf('eventObj') >= 0
        "
      >
        <el-form-item label="触发事件">
          <span slot="label" class="sw-2-title">事件触发方式： </span>
          <el-select
            v-model="data.eventOptions.eventType"
            clearable
            placeholder="请选择事件触发方式"
            style="margin-bottom: 20px"
          >
            <el-option
              v-if="data.type === 'button'"
              label="点击"
              value="click"
            ></el-option>
            <el-option label="改变值" value="change"></el-option>
            <el-option label="失去焦点" value="blur"></el-option>
            <el-option
              v-if="data.type === 'input'"
              label="输入框值改变"
              value="input"
            ></el-option>
          </el-select>
          <draggable
            tag="ul"
            :list="data.eventOptions.eventObj"
            v-bind="{
              group: { name: 'options' },
              ghostClass: 'ghost',
              handle: '.drag-item',
            }"
            handle=".drag-item"
          >
            <li
              v-for="(item, index) in data.eventOptions.eventObj"
              :key="index"
            >
              <i
                class="drag-item"
                style="font-size: 16px; margin: 0 5px; cursor: move"
                ><i class="iconfont icon-icon_bars"></i
              ></i>
              事件{{ index + 1 }}
              <el-button
                @click="editEvent(item, index)"
                circle
                plain
                type="Info"
                size="mini"
                icon="el-icon-edit"
                style="padding: 4px; margin-left: 5px"
              ></el-button>
              <el-button
                @click="remove(index)"
                circle
                plain
                type="danger"
                size="mini"
                icon="el-icon-minus"
                style="padding: 4px; margin-left: 5px"
              ></el-button>
            </li>
          </draggable>
          <el-button
            type="text"
            icon="el-icon-plus"
            size="mini"
            @click="addEvent"
            >添加事件</el-button
          >
        </el-form-item>

        <el-form-item
          v-if="
            data.type !== 'editor' &&
            Object.keys(data.eventOptions).indexOf('count') >= 0
          "
          label="自定义计算"
        >
          <el-input
            type="textarea"
            :rows="3"
            v-model="data.eventOptions.count.formula"
            disabled
          >
          </el-input>
          <el-button
            type="text"
            icon="el-icon-edit-outline"
            size="mini"
            @click="countFunc"
            >设置自定义计算</el-button
          >
        </el-form-item>

        <el-form-item v-if="data.type === 'date'">
          <span slot="label"
            >日期禁用表达式配置
            <el-tooltip
              class="item"
              effect="dark"
              placement="bottom-start"
              style="margin-right: 10px"
            >
              <div slot="content" class="dateConfigDiv">
                <span class="dateConfigSpan">dateNum：表示月份中某一天</span
                ><br />
                <span class="dateConfigSpan">monthNum：表示月份</span><br />
                <span class="dateConfigSpan">yearNum：表示年份</span><br />
                <span class="dateConfigSpan"
                  >weekNum：表示周几； 1 到 7 分别对应 周一 到 周日</span
                ><br />
                <span class="dateConfigSpan"
                  >&amp;&amp;：表示取交集<br />||：表示取并集<br />()：表示优先处理</span
                ><br />
                <span class="dateConfigSpan spanFontW"
                  >注意：该表达式必须返回布尔值； <br />eg. 禁用周三 weekNum%7
                  === 3 <br />eg. 禁用28号 dateNum%28 === 0 <br />eg. 禁用三月份
                  monthNum === 3 <br />eg. 禁用7月28日 monthNum === 7 &amp;&amp;
                  dateNum%28 === 0 <br />eg. 禁用2019年和每年8月 yearNum ===
                  2019 || monthNum === 8 <br />eg. 禁用当天及当天之前的日期
                  time.getTime() &lt; Date.now()<br />eg. 禁用当天之前的日期
                  time.getTime() &lt; Date.now() - 8.64e7</span
                ><br />
              </div>
              <span style="color: #ff9343"
                ><i class="el-icon-warning"></i
              ></span>
            </el-tooltip>
          </span>
          <el-input v-model="data.options.disabledDate" clearable>
            <el-button
              @click="checkExpression"
              slot="append"
              type="primary"
              round
              >验证</el-button
            >
          </el-input>
        </el-form-item>
      </template>
    </el-form>

    <!-- 配置字段事件开始 -->
    <el-dialog
      v-if="data.eventOptions"
      title="新增事件"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <event
        :dialog-event="dataEvent"
        :design-id="designId"
        :data-list="componentsList"
        :is-son="data.options.isSon"
        :event-type="data.eventOptions.eventType"
        :dialogVisible.sync="dialogVisible"
      ></event>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBack">返 回</el-button>
        <el-button type="primary" @click="dialogSave">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 配置字段事件结束 -->

    <!-- 配置字段计算开始 -->
    <el-dialog
      title="计算公式"
      :visible.sync="dialogCount"
      width="700px"
      :before-close="handleCountClose"
    >
      <SwCount
        :design-id="designId"
        :data-list="componentsList"
        :is-son="data.options.isSon"
        :data="data"
        :name-map="modelToNameList"
        :dialogVisible.sync="dialogCount"
      ></SwCount>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCountBack">返 回</el-button>
        <el-button type="primary" @click="dialogCountSave">确 认</el-button>
      </span>
    </el-dialog>
    <!-- 配置字段计算结束 -->
  </div>
</template>

<script>
import formUtils from '../util/formUtils'
import Draggable from 'vuedraggable'
import event from './event/event'
import SwCount from './count/SwCount'
import alertUtils from '../util/alertUtils'
export default {
  name: 'sw-event-config',
  components: {
    Draggable,
    event,
    SwCount,
  },
  props: ['designId', 'data', 'pageTab', 'widgetForm'],
  data() {
    return {
      componentsList: null,
      modelToNameList: null,
      dataList:
        this.pageTab === 'main'
          ? this.widgetForm.list
          : this.widgetForm.sonPages[this.pageTab],
      dialogCount: false, // 计算弹框
      dialogVisible: false, // 弹出框是否显示
      dialogConfig: {
        functions: '',
        eventList: [],
      },
      dataCalculationList: [],
      dataEvent: {},
      dataEventBp: {},
      dialogIndex: -1,
    }
  },
  created() {
    this.dataEvent = {} // 初始化dataEvent
    this.dataEventBp = {}
    this.dialogIndex = -1
  },
  computed: {
    show() {
      if (this.data && Object.keys(this.data).length > 0) {
        return true
      }
      return false
    },
  },
  methods: {
    addEvent() {
      if (
        !this.data.eventOptions.eventType ||
        this.data.eventOptions.eventType === ''
      ) {
        alertUtils.alertError('创建事件前，需先选择事件触发方式', true)
        return
      }
      this.refreshList()
      this.componentsList = formUtils.getComponentsListInfo(this.dataList)
      this.dataEvent = JSON.parse(JSON.stringify(this.dialogConfig))
      this.dataEventBp = {}
      this.dialogIndex = -1
      this.data.eventOptions.eventObj.push(this.dataEvent)
      this.dialogVisible = true
    },
    editEvent(obj, index) {
      // 修改事件
      this.refreshList()
      this.componentsList = formUtils.getComponentsListInfo(this.dataList)
      this.dataEvent = obj
      this.dataEvent.eventList.forEach(item => {
        if (
          typeof item.condition === 'undefined' ||
          item.condition === null ||
          item.condition.length <= 0
        ) {
          if (
            typeof item.field !== 'undefined' &&
            item.field !== null &&
            item.field !== ''
          ) {
            this.$set(item, 'condition', [])
            item.condition.push({
              field: item.field,
              expression: item.expression,
              value: item.value,
              relation: '',
            })
          }
        }
      })
      this.dataEventBp = JSON.parse(JSON.stringify(obj))
      this.dialogIndex = index
      this.dialogVisible = true
    },
    remove(index) {
      this.$confirm('确认删除事件？')
        .then(() => {
          this.data.eventOptions.eventObj.splice(index, 1)
        })
        .catch(() => {})
    },
    dialogSave() {
      this.dialogVisible = false
      this.dataEvent = {}
      this.dataEventBp = {}
    },
    dialogBack() {
      this.dialogVisible = false
      this.dataEvent = {}
      this.data.eventOptions.eventObj[this.dialogIndex] = this.dataEventBp
      this.dialogIndex = -1
      this.dataEventBp = {}
    },
    countFunc() {
      this.refreshList()
      this.componentsList = formUtils.componentsInfoDelOthers(
        formUtils.getComponentsListInfo(this.dataList),
        'sonform,page',
        false
      )
      this.modelToNameList = formUtils.modelToName(this.componentsList)
      if (Object.keys(this.data.eventOptions.count).indexOf('list') < 0) {
        this.$set(this.data.eventOptions.count, 'list', [])
      }
      if (Object.keys(this.data.eventOptions.count).indexOf('formula') < 0) {
        this.$set(this.data.eventOptions.count, 'formula', null)
      }
      if (Object.keys(this.data.eventOptions.count).indexOf('relation') < 0) {
        this.$set(this.data.eventOptions.count, 'relation', {})
      }
      if (Object.keys(this.data.eventOptions.count).indexOf('result') < 0) {
        this.$set(this.data.eventOptions.count, 'result', '')
      }
      this.dialogCount = true
    },
    dialogCountSave() {
      this.dialogCount = false
    },
    dialogCountBack() {
      this.dialogCount = false
    },
    handleCountClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.dialogCountBack()
          done()
        })
        .catch(() => {})
    },
    handleClose(done) {
      this.$confirm('确认关闭，不保存？')
        .then(() => {
          this.dialogBack()
          done()
        })
        .catch(() => {})
    },
    checkExpression() {
      // 验证表达式是否正确
      // const dateNum = 2; const monthNum = 2; const yearNum = 2; const weekNum = 2
      // const time = new Date()
      const time = new Date()
      const dateNum = time.getDate()
      const monthNum = time.getMonth() + 1
      const yearNum = time.getFullYear()
      const weekNum = time.getDay() === 0 ? 7 : time.getDay()
      try {
        eval(
          this.data.options.disabledDate,
          time,
          dateNum,
          monthNum,
          yearNum,
          weekNum
        )
        alertUtils.alertSuccess('表达式格式输入正确', true)
      } catch (e) {
        alertUtils.alertError('表达式输入错误，不符合规范', true)
      }
    },
    refreshList() {
      if (this.pageTab === 'main') {
        this.dataList = this.widgetForm.list
      } else {
        this.dataList = this.widgetForm.sonPages[this.pageTab].list
      }
    },
  },
  watch: {
    'data.model': {
      deep: true,
      handler() {
        if (Object.keys(this.data).indexOf('eventOptions') >= 0) {
          if (Object.keys(this.data.eventOptions).indexOf('count') < 0) {
            // 增加计算属性
            this.$set(this.data.eventOptions, 'count', {})
          }
        }
      },
    },
    pageTab() {
      this.refreshList()
    },
  },
}
</script>

<style scoped>
.dateConfigDiv {
  margin-left: 10px;
}
.spanFontW {
  font-weight: bold;
}
</style>
